// More robust solution that handles both initial load and dynamic changes
(function() {
  let observer = null;
  
  function setupObserver() {
    const cartCountElement = document.querySelector('.header__cart-count cart-count.count-bubble');
    const headerCartCount = document.querySelector('.header__cart-count');
    
    if (cartCountElement && headerCartCount) {
      // Disconnect any existing observer
      if (observer) {
        observer.disconnect();
      }
      
      console.log('Cart count element found and configured');
      
      // Define the updateVisibility function
      function updateVisibility() {
        const countText = cartCountElement.textContent.trim();
        const count = parseInt(countText, 10);
        const shouldHide = count === 0 || isNaN(count);
        
        if (shouldHide) {
          // Hide the parent div
          headerCartCount.style.visibility = 'hidden';
          console.log('Cart count is 0, hiding parent div');
        } else {
          // Show the parent div
          headerCartCount.style.visibility = 'visible';
          console.log('Cart count is', count, 'showing parent div');
        }
      }
      
      // Initial update
      updateVisibility();
      
      // Create and start observer on the cart-count element to watch for changes
      observer = new MutationObserver(updateVisibility);
      observer.observe(cartCountElement, { 
        childList: true, 
        characterData: true, 
        subtree: true 
      });
      
      console.log('Observer setup complete');
      return true;
    }
    return false;
  }
  
  // Try on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    if (!setupObserver()) {
      console.log('Element not found on DOMContentLoaded, watching for changes...');
      
      // Watch for dynamic additions
      const watchObserver = new MutationObserver(function() {
        if (setupObserver()) {
          watchObserver.disconnect(); // Stop watching once found
        }
      });
      
      watchObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });
  
  // Also try immediately in case DOM is already loaded
  if (document.readyState === 'loading') {
    // DOM not ready yet, our event listener will handle it
  } else {
    // DOM is already ready
    if (!setupObserver()) {
      // If not found, start watching
      const watchObserver = new MutationObserver(function() {
        if (setupObserver()) {
          watchObserver.disconnect();
        }
      });
      
      watchObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
})();